import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(3599);
  return <div className="fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-[#DC2626] to-[#991B1B] text-white py-2 px-4 shadow-lg" data-id="element-231">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-sm sm:text-base font-medium" data-id="element-232">
        <span data-id="element-233">
          ¡OFERTA DE LANZAMIENTO! Acceso al Blueprint "Teen Pro" por solo $6.39
          USD (Valor regular $47). El tiempo corre:
        </span>
        <span className="font-mono font-bold text-[#39FF14] drop-shadow-[0_0_5px_rgba(57,255,20,0.8)] bg-black/30 px-2 py-1 rounded" data-id="element-234">
          [{hours}:{minutes}:{seconds}]
        </span>
      </div>
    </div>;
}